<div class="login-container">
  <form class="auth-form" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
    <h3>Login</h3>
    
    <div class="form-group">
      <label for="username">Username</label>
      <input id="username" formControlName="username" type="text" required autocomplete="username" placeholder="Enter your username" />
    </div>

    <div class="form-group">
      <label for="password">Password</label>
      <input id="password" formControlName="password" type="password" required autocomplete="current-password" placeholder="Enter your password" />
    </div>

    <div class="btn-group">
      <button class="btn-primary" type="submit">Login</button>
      <button class="btn-secondary" type="button" (click)="logOut()">Logout</button>
    </div>

    <p *ngIf="errorMessage" class="error-message">{{ errorMessage }}</p>
  </form>
</div>